import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
import { CardContainer } from './CardContainer';
export const Card = ({ children, title, contentSpacing, cardVariant = 'white', overflow, ...restCardContainerProps }) => {
    return (_jsx(CardContainer, { cardVariant: cardVariant, overflow: overflow, ...restCardContainerProps, children: _jsxs(FlexContainer, { overflow: overflow, direction: 'column', spacing: true, ...contentSpacing, children: [title && (_jsx(Box, { spacingBottom: '2', children: _jsx(Text, { variant: 'h3', children: title }) })), children] }) }));
};
